export default "__VITE_ASSET__DHWybvCt__"